import { FC } from 'react';

// Define the keyframes animation for loading dots
const loadingAnimation = `
@keyframes loading {
  0% { opacity: 0; }
  50% { opacity: 1; }
  100% { opacity: 0; }
}
`;

export const LoadingDots: FC = () => (
  <>
    <style>{loadingAnimation}</style>
    <span className="inline-flex">
      <span className="animate-[loading_1.4s_ease-in-out_infinite] opacity-0">.</span>
      <span className="animate-[loading_1.4s_ease-in-out_0.2s_infinite] opacity-0">.</span>
      <span className="animate-[loading_1.4s_ease-in-out_0.4s_infinite] opacity-0">.</span>
    </span>
  </>
);

/** Bouncing circle dots — use for chat/AI loading indicators */
export const BouncingDots: FC = () => (
  <div className="flex gap-1">
    <span className="w-1.5 h-1.5 rounded-full bg-primary animate-bounce [animation-delay:0ms]" />
    <span className="w-1.5 h-1.5 rounded-full bg-primary animate-bounce [animation-delay:150ms]" />
    <span className="w-1.5 h-1.5 rounded-full bg-primary animate-bounce [animation-delay:300ms]" />
  </div>
);

export default LoadingDots;
